import React, { useState } from "react";
import { Form, Select, Input, Empty } from "antd";

const RenderFilterFields = ({ filtersData = [], onFieldChange = () => {} }) => {
  const [form] = Form.useForm();

  const handleChange = (value, filterCode, filterType) => {
    onFieldChange(filterCode, value);
  };

  const getOptions = (filter) => {
    return filter.filter_values?.filter(Boolean).map((val, index) => ({
      label: val.value,
      value: val.code,
      key: `${val.code}-${index}`,
    }));
  };

  return (
    <>
      {filtersData.length === 0 ? (
        <Empty description="No filters available" />
      ) : (
        filtersData.map((filter) => {
          switch (filter.filter_type) {
            case "code_name_spinner":
              return (
                <Form.Item
                  key={filter.filter_code}
                  label={filter.filter_title}
                  name={filter.filter_code}
                  initialValue={filter.default_filter_value}
                >
                  <Select
                    allowClear
                    mode={filter.is_single_select ? undefined : "multiple"}
                    options={getOptions(filter)}
                    placeholder={`Select ${filter.filter_title}`}
                    defaultValue={filter.default_filter_value}
                    onChange={(value) =>
                      handleChange(
                        value,
                        filter.filter_code,
                        filter.filter_type
                      )
                    }
                    showSearch
                    notFoundContent={
                      filter.filter_values?.length ? null : (
                        <Empty description="No options available" />
                      )
                    }
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              );

            case "text":
              return (
                <Form.Item
                  key={filter.filter_code}
                  name={filter.filter_code}
                  label={filter.filter_title}
                >
                  <Input
                    placeholder={`Enter ${filter.filter_title}`}
                    onChange={(e) =>
                      handleChange(
                        e.target.value,
                        filter.filter_code,
                        filter.filter_type
                      )
                    }
                  />
                </Form.Item>
              );

            default:
              return null;
          }
        })
      )}
    </>
  );
};

export default RenderFilterFields;
